import { FC, useMemo, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { performMixedAccountOperationActionCreator } from 'actions/linkageActions'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

type AccountActionLinkHandlerProps = {
  accountInfo: MixedAccountsTableItem
}

export const AccountActionLinkHandler: FC<AccountActionLinkHandlerProps> = (props) => {
  const { accountInfo, children } = props
  const { type, account, providerAccount } = accountInfo
  const { link_status = false } = account || {}

  const dispatch = useStoreDispatch()

  const handleClick = useCallback(() => {
    const currentAccount = type === 'manual'
      ? account
      : account || providerAccount

    if (!currentAccount) {
      return
    }

    dispatch(performMixedAccountOperationActionCreator.request({ account: currentAccount, operation: 'link' }))
  }, [dispatch, account, providerAccount, type])

  const isExist = useMemo(() => {
    return link_status === 'unlinked' && type !== 'manual'
  }, [type, link_status])

  if (!isExist) {
    return null
  }

  return (
    <div onClick={ handleClick }>
      { children }
    </div>
  )
}
